export enum CargaMatriculesEnum {
    CargaXaloc = 'CargaXaloc',
    ExportXaloc = 'ExportXaloc',
    CargaGestioTributaria = 'CargaGestioTributaria',
    CargaDgt = 'CargaDgt',
    CargaDgtTotal = 'CargaDgtTotal'
  }
